/**
 * Etend une zone de clic vers une page de destination
 * la zone d'extension doit porter la classe .extend-click
 * l'url à suivre doit être sur un lien href et porter la classe .extend-url
 */
// var extendClickimclicked = false
// function tClick() {
//  $('.t-click').off('click').on('click', function (e) {
//    if ( !$(e.target).is('a') ) { // ne s'applique pas sur le clic d'un a.href sinon clic 2 fois sur le lien sur firefox par exemple et c'est problématique avec des target="_blank"
//      if ( !extendClickimclicked ) {
//        var a = $(this).find('a.t-url')
//        a.get(0).click()
//      }
//    }
//  })
//  $('.t-click a.t-url').off('click').on('click', function (e) {
//    extendClickimclicked = true
//    setTimeout(function() {
//      extendClickimclicked = false
//    }, 100)
//  })
// }

/**
 * Affiche un loader à un élément
 * @param {boolean} i = true Affiche ou non le loader
 */
$.fn.load = function (i = true) {
  if (i) {
    this.find('.load').stop(true, true).animate({ opacity: .5 }, 200)
    this.find('input, button, textarea, select').prop('disabled', true)
    $(this.find('.processing')[0]).stop(true, true).show().animate({ opacity: 1 }, 200)
  } else {
    this.addClass('loaded')
    this.find('.load').stop(true, true).animate({ opacity: 1 }, 200)
    this.find('input, button, textarea, select').prop('disabled', false)
    $(this.find('.processing')[0]).stop(true, true).animate({ opacity: 0 }, 200, function () { $(this).hide() })
  }
}

/*
// Wait while GMap API is loading
function dtectMap(action) {
  if ( $('body').hasClass('maploaded') ) {
    //console.log('maploaded')
    action()
  } else {
    setTimeout(function() {
      dtectMap(action)
    }, 200)
  }
}
*/

// Extend function json objects to merge as arguments (for a deep extend, set the first argument to `true`)
export const extend = function () {
  // Variables
  const extended = {}
  let deep = false
  let i = 0
  const length = arguments.length
  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0]
    i++
  }
  // Merge the object into the extended object
  const merge = function (obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop])
        } else {
          extended[prop] = obj[prop]
        }
      }
    }
  }
  // Loop through each object and conduct a merge
  for (; i < length; i++) {
    const obj = arguments[i]
    merge(obj)
  }
  return extended
}